// extracted by mini-css-extract-plugin
export default {"feedback":"restore_feedback__ZW-8X","close":"restore_close__VTs1F"};